<script>
  import {Bar} from 'vue-chartjs'

  export default {
    name: "VendasPorPeriodo",
    extends: Bar,
    props: {dados:''},

    computed: {
      chartData() {
        return this.dados;
      }
    },

    methods: {
      renderizarGrafico() {
        let labels = this.chartData.map(e => {
          return e.dt_venda;
        });

        let datasets = this.chartData.map(e => {
          return e.valor;
        });

        let data = {
          labels: labels,
          datasets: [{
            label: 'Vendas no período',
            data: datasets,
            backgroundColor: '#3e95cd',
            borderWidth: 1
          }]
        };

        let options = {
          legend: {
            display: false
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          }
        };

        this.renderChart(data, options)
      },

    },

    watch: {
      dados() {
        this.$data._chart.destroy();
        this.renderizarGrafico();
      }
    },

    mounted() {
      this.renderizarGrafico();
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/relatorio/graficos/VendasPorPeriodo.vue